import { render } from "./SettingsComponent.vue?vue&type=template&id=5a7a9c7c&scoped=true"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"

import "./SettingsComponent.vue?vue&type=style&index=0&id=5a7a9c7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7a9c7c"]])

export default __exports__